import { useQuery } from 'react-query';

import { Payload, PivotTableGroupDetails, QueryResponse, getPivotTable } from 'api/endPoints/getPivotTable';

export const getPivotTableKey = 'getPivotTable';

export const useQueryGetPivotTable = (params: Payload, endpoint: string, isPivotTableIsInView: boolean) => {
    return useQuery<QueryResponse, QueryError, PivotTableGroupDetails[]>({
        queryKey: [getPivotTableKey, params],
        queryFn: ({ signal }) => getPivotTable(params, endpoint, signal),
        select: (response) => {
            return response.groupList ?? [];
        },
        enabled: isPivotTableIsInView && params.cardCachedFilter?.filter?.filters.length !== 0,
    });
};
